/* global EventEmitter */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import isFunction from "lodash/isFunction";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import clone from "lodash/cloneDeep";
import SocialMemberBubble from "../containers/SocialMemberBubble";
import { injectIntl } from "react-intl";
import Icon from "./Icon";
// This component is used for editing spheres a.k.a groups a.k.a. communities inside the activity center
var SocialSphereEditor = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(SocialSphereEditor, PureComponent);
    var _super = _createSuper(SocialSphereEditor);
    function SocialSphereEditor(props) {
        _classCallCheck(this, SocialSphereEditor);
        var _this;
        _this = _super.call(this, props);
        _this.renderUser = function(user) {
            var isInfoView = _this.props.isInfoView;
            var isSelected = _this._isUserSelected(user.id);
            var selectedCss = classNames("multi-select__indicator", {
                "multi-select__indicator--selected": isSelected
            });
            var userCss = classNames("sphere-editor__user-item", {
                "sphere-editor__user-item--inactive": !user.is_active
            });
            var linkClassNames = classNames("multi-select__link", {
                "multi-select__link--disabled": _this.props.isInfoView === true
            });
            return /*#__PURE__*/ React.createElement("li", {
                className: userCss,
                key: user.id
            }, /*#__PURE__*/ React.createElement("a", {
                href: "#",
                onClick: function(evnt) {
                    evnt.preventDefault();
                    if (!isInfoView) {
                        _this._onToggleUser(user);
                    }
                },
                className: linkClassNames
            }, /*#__PURE__*/ React.createElement(SocialMemberBubble, {
                members: [
                    user
                ]
            }), /*#__PURE__*/ React.createElement("span", {
                className: "multi-select__label"
            }, user.name), !isInfoView && /*#__PURE__*/ React.createElement("span", {
                className: selectedCss,
                "aria-hidden": "true"
            }, isSelected ? /*#__PURE__*/ React.createElement(Icon, {
                name: "checkmark-bold",
                size: "m"
            }) : /*#__PURE__*/ React.createElement(Icon, {
                name: "add-user",
                size: "m"
            }))));
        };
        _this._isUserSelected = function(id) {
            return !!_this.state.group && !!_this.state.group.members.find(function(u) {
                return u.id === id;
            });
        };
        _this._onToggleUser = function(user) {
            var group = clone(_this.state.group);
            if (group) {
                group.members = group.members || [];
                if (group.members.find(function(u) {
                    return u.id === user.id;
                })) {
                    group.members = group.members.filter(function(u) {
                        return u.id !== user.id;
                    });
                } else {
                    group.members.push(user);
                }
            }
            _this.setState({
                group: group
            });
        };
        _this._onFilterUser = function(evnt) {
            var _this_props = _this.props, isInfoView = _this_props.isInfoView, sphere = _this_props.sphere, users = _this_props.users;
            var regex = new RegExp(evnt.target.value, "i");
            var allUser = isInfoView ? sphere ? sphere.members.slice() : [] : users;
            _this.setState({
                filteredUsers: evnt.target && !!evnt.target.value.length ? allUser.filter(function(u) {
                    return !!u.name.match(regex);
                }) : allUser
            });
        };
        _this._onNameChange = function(evnt) {
            var val = evnt.target.value;
            var group = clone(_this.state.group);
            if (group) {
                group.name = val;
            }
            _this.setState({
                group: group
            });
        };
        _this._updateGroup = function() {
            var group = _this.state.group;
            var _this_props = _this.props, updateGroup = _this_props.updateGroup, createGroup = _this_props.createGroup;
            if (group) {
                if (_this._isGroupPersisted(group)) {
                    updateGroup(group);
                } else {
                    createGroup(group);
                }
            }
        };
        _this._onGroupUpdated = function(newGroup) {
            var _this_props = _this.props, sphere = _this_props.sphere, session = _this_props.session, onChange = _this_props.onChange;
            if (!sphere || !_this._isGroupPersisted(sphere)) {
                // = Newly added group which is not yet persisted
                if (session) {
                    var user = {
                        id: session.id,
                        name: session.name,
                        is_active: session.is_active,
                        foreign_id: session.foreign_id
                    };
                    _this.setState({
                        group: sphere ? clone(sphere) : _this._buildNewGroup(user),
                        isEditing: false
                    });
                }
            } else {
                // = Updated group
                _this.setState({
                    group: newGroup,
                    isEditing: false
                });
            }
            if (isFunction(onChange)) {
                onChange(newGroup);
            }
        };
        // TO DO: this will need refining to be able to give precise and understandable error messages!
        // The intl message ids need to be built exactly as before (see commented out code)
        _this._onInvalidUpdate = function(error) {
            var intl = _this.props.intl;
            var msg = "<div>".concat(intl.formatMessage({
                id: "ui.validation_error"
            }), "<br/><ul>");
            msg += "<li>".concat(error.name, ": ").concat(error.message, "</li>");
            // each(error, (elm, key) => {
            // each(error, (err) => {
            //   msg += `<li>${
            //     err.indexOf(' ') > -1
            //       ? err
            //       : intl.formatMessage({
            //           id: 'social.spheres.validations.' + key + '.' + err,
            //           defaultMessage: `validation error for ${key}: ${err}`
            //         })
            //   }</li>`
            // })
            // })
            msg += "</ul></div>";
            _this.props.sendAlert(msg, "danger");
        };
        _this._handleAction = function(eventName) {
            var _this_props = _this.props, session = _this_props.session, sphere = _this_props.sphere;
            switch(eventName){
                case "save":
                    _this._updateGroup();
                    break;
                case "cancel":
                    if (session) {
                        var user = {
                            id: session.id,
                            name: session.name,
                            is_active: session.is_active,
                            foreign_id: session.foreign_id
                        };
                        _this.setState({
                            group: sphere ? clone(sphere) : _this._buildNewGroup(user),
                            isEditing: false
                        });
                    }
                    break;
                default:
                    break;
            }
        };
        _this.state = {
            filteredUsers: [],
            group: props.sphere ? clone(props.sphere) : props.session ? _this._buildNewGroup({
                id: props.session.id,
                name: props.session.name,
                is_active: props.session.is_active,
                foreign_id: props.session.foreign_id
            }) : null,
            isEditing: false
        };
        return _this;
    }
    var _proto = SocialSphereEditor.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this_props = this.props, action = _this_props.action, isInfoView = _this_props.isInfoView, users = _this_props.users, sphere = _this_props.sphere, session = _this_props.session;
        var group = this.state.group;
        if (action) {
            action.addListener("action", this._handleAction);
        }
        this.setState({
            group: sphere ? clone(sphere) : session ? this._buildNewGroup({
                id: session.id,
                name: session.name,
                is_active: session.is_active,
                foreign_id: session.foreign_id
            }) : null,
            filteredUsers: isInfoView ? (group === null || group === void 0 ? void 0 : group.members) ? group === null || group === void 0 ? void 0 : group.members.slice() : [] : users
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, isInfoView = _this_props.isInfoView, sphere = _this_props.sphere, users = _this_props.users, session = _this_props.session, updateGroupError = _this_props.updateGroupError, isUpdatingGroup = _this_props.isUpdatingGroup;
        // if group has changed or if isInfoView has changed
        if (!isEqual(sphere, prevProps.sphere) || isInfoView !== prevProps.isInfoView) {
            var group = sphere ? clone(sphere) : session ? this._buildNewGroup({
                id: session.id,
                name: session.name,
                is_active: session.is_active,
                foreign_id: session.foreign_id
            }) : null;
            this.setState({
                group: group,
                filteredUsers: isInfoView ? (group === null || group === void 0 ? void 0 : group.members) ? group.members.slice() : [] : users
            });
        }
        // check if a group has been updated
        if (prevProps.isUpdatingGroup && !isUpdatingGroup) {
            this._onGroupUpdated(sphere);
        }
        // check if there has been an error when updating a group
        if (!prevProps.updateGroupError && !!updateGroupError) {
            this._onInvalidUpdate(updateGroupError);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.action) {
            this.props.action.removeListener("action", this._handleAction);
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, intl = _this_props.intl, isInfoView = _this_props.isInfoView, sphere = _this_props.sphere;
        var filteredUsers = this.state.filteredUsers;
        var filterClassNames = classNames("social-app-options__form-control social-app-options__form-control--prepend icon-filter", {
            "social-app-options__form-control--full-width": isInfoView === true
        });
        var groupName = sphere && !!sphere.name ? '"' + sphere.name + '"' : intl.formatMessage({
            id: "social.activities.group",
            defaultMessage: "Group"
        });
        var filterPlaceholder = intl.formatMessage({
            id: "social.activities.filter_group",
            defaultMessage: "filter: {group}"
        }, {
            group: groupName
        });
        return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-options"
        }, !isInfoView && /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__form-control"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "community",
            size: "s"
        }), /*#__PURE__*/ React.createElement("input", {
            className: "social-app-options__input social-app-options__input--name",
            type: "text",
            defaultValue: sphere && sphere.name || "",
            placeholder: intl.formatMessage({
                id: "social.activities.group_name",
                defaultMessage: "group name"
            }),
            onKeyUp: this._onNameChange
        })), /*#__PURE__*/ React.createElement("span", {
            className: filterClassNames
        }, /*#__PURE__*/ React.createElement("input", {
            className: "social-app-options__input social-app-options__input--filter",
            type: "text",
            onKeyUp: this._onFilterUser,
            placeholder: filterPlaceholder
        }), /*#__PURE__*/ React.createElement(Icon, {
            name: "filter",
            size: "s"
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "sphere-editor"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "sphere-editor__results",
            role: "alert"
        }, filteredUsers.length ? intl.formatMessage({
            id: "social.spheres.filter_users_results",
            defaultMessage: "{count} users found"
        }, {
            count: filteredUsers.length
        }) : intl.formatMessage({
            id: "social.spheres.filter_users_empty",
            defaultMessage: "No users found"
        })), /*#__PURE__*/ React.createElement("ul", {
            className: "sphere-editor__user-list"
        }, filteredUsers.map(this.renderUser))));
    };
    _proto._buildNewGroup = function _buildNewGroup(owner) {
        return {
            id: undefined,
            activity_count: 0,
            name: "",
            members: [
                owner
            ],
            owner: owner,
            is_visible: true,
            last_activity: null,
            note: true,
            unread_topics: 0
        };
    };
    _proto._isGroupPersisted = function _isGroupPersisted(group) {
        // groups that haven't been persisted on the server have undefined as id
        return group.id ? group.id >= 0 : false;
    };
    return SocialSphereEditor;
}(PureComponent);
export var Component = SocialSphereEditor;
export default injectIntl(SocialSphereEditor);
